import { useApolloClient } from '@apollo/client'
import { useGraphqlFetchAndCacheWithKey } from '@mostrans/web-components/hooks/useGraphqlFetchAndCacheWithKey'
import { ActiveOpportunityAtom } from '../OpportunityAtoms'
import { getActiveOpportunities } from '../OpportunityQueries'

export const useGetActiveOpportunities = (userId) => {
    const client = useApolloClient()
    return useGraphqlFetchAndCacheWithKey({
        atom: ActiveOpportunityAtom,
        variables: userId,
        initialValue: null,
        getData: (userId) => getActiveOpportunities(client, {
            userId
        })
    })
}
